import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Creators as menuActions } from '../../store/ducks/menu-ativo';

import RootView from '../rootView';
import ListaPedidoWrapper from '../listaPedidoWrapper';

import { PEDIDO_STATUS } from '../../constants/status-pedido';

class HistoricoPedido extends Component {
    componentDidMount() {
        this.props.selectMenu('history-filled');
    }

    render() {
        const { navigation } = this.props;
        const statusPedidosList = `${PEDIDO_STATUS.SEPARADO},${
            PEDIDO_STATUS.EM_TRANSPORTE
        },${PEDIDO_STATUS.FINALIZADO},${PEDIDO_STATUS.DISPONIVEL_RETIRADA},${
            PEDIDO_STATUS.DISPONIVEL_RETIRADA_LOCKER
        },${PEDIDO_STATUS.CANCELADO}`;

        const idStatusList = `${PEDIDO_STATUS.SEPARADO},${
            PEDIDO_STATUS.EM_TRANSPORTE
        },${PEDIDO_STATUS.FINALIZADO},${PEDIDO_STATUS.DISPONIVEL_RETIRADA}`;

        return (
            <RootView navigation={navigation}>
                <ListaPedidoWrapper
                    isHistorico={true}
                    navigation={navigation}
                    showItemActions={false}
                    showOrderCounter={false}
                    idStatusPedido={statusPedidosList}
                    idStatusList={idStatusList}
                />
            </RootView>
        );
    }
}

const mapStateToProps = ({ menuAtivo }) => ({
    menuAtivo
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ ...menuActions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(HistoricoPedido);
